import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { DeviceUser } from '../models';
import { GetDeviceCodeResponse } from '../models/response/get-device-code.response.model';

@Injectable({
  providedIn: 'root',
})
export class DeviceGroupService {
  constructor(private readonly httpClient: HttpClient) {}

  saveToDeviceGroup(packageUserGuid: string, deviceCode: string, isSavingForRejoiningUser = false) {
    return this.httpClient.post(`deviceGroups/${deviceCode}`, { packageUserGuid, isSavingForRejoiningUser });
  }

  associateToDevice(packageUserGuid: string, deviceCode: string) {
    return this.httpClient.post(`deviceGroups/${deviceCode}/unverified`, { packageUserGuid });
  }

  getDeviceUsers(packageGuid: string, deviceCode: string) {
    return this.httpClient.get<DeviceUser[]>(`deviceGroups/${deviceCode}/packages/${packageGuid}`);
  }

  getNewDeviceCode(isPresign: boolean) {
    return this.httpClient.get<GetDeviceCodeResponse>(
      `deviceGroups/deviceCode/isPresign/${isPresign}`
    );
  }

  getVerifiedDeviceCode(deviceCode: string) {
    return this.httpClient.get<GetDeviceCodeResponse>(`deviceGroups/deviceCode/${deviceCode}`);
  }

  revisitSession(deviceCode: string, packageGuid: string) {
    return this.httpClient.post(`session/revisited`, { sessionId: deviceCode, packageGuid });
  }

  rejoin(packageUserGuid: string, deviceCode: string) {
    return this.httpClient.post(`deviceGroups/rejoin`, { packageUserGuid, deviceCode });
  }

  addUserToDevice(packageUserGuid: string, deviceCode: string) {
    return this.httpClient.post(`deviceGroups/rejoin`, { packageUserGuid, deviceCode });
  }
}
